export class ArtistLocationsSearchRequest {
    artistId?: string;
    city?: string;
    state?: string;
    postalCode?: string;
    latitude?: number;
    longitude?: number;
    milesRadius?: number;
    startDate?: string;
    endDate?: string;

    constructor(init?: Partial<ArtistLocationsSearchRequest>) {
        Object.assign(this, init);
    }
}